export default "__VITE_ASSET__kZtAk4lN__"